import { Typography } from '@statsbomb/kitbag-components';
import type { ComponentProps, ReactNode } from 'react';

export type TypographyVariant = ComponentProps<typeof Typography>['variant'];

/*
 * Links an entity name to its IQ Classic page. Without an href (the entity has no Classic id)
 * the name is shown as plain text so no broken Classic URL is ever rendered.
 */
export const ClassicEntityLink = ({
  href,
  variant,
  children,
}: {
  href?: string;
  variant: TypographyVariant;
  children: ReactNode;
}) =>
  href ? (
    <Typography as="a" variant={variant} href={href}>
      {children}
    </Typography>
  ) : (
    <Typography as="span" variant={variant}>
      {children}
    </Typography>
  );
